module.exports = __webpack_public_path__ + "static/g3-b5c2fd5131547abf86be2b0a22d7ab76.svg";